import { clsx } from 'clsx'
import { Space } from 'component/Space'
import { ReactNode } from 'react'
import { opt } from 'store/opt'
import { styles } from 'util/style'
import css from './Panel.module.scss'

type Props = {
  auto?: boolean
  base?: number
  children: ReactNode
}

export const Panel = ({ auto, base, children }: Props) => {
  const panel = !opt.tsum || opt.stand
  const className = clsx(!auto && css.base, opt.stand && css.stand)
  const style = styles({ '--base-width': base ? base + 'px' : undefined })
  const gap = opt.stand ? 8 : 4

  return <Space className={className} style={style} gap={gap} panel={panel} spread={auto} wide wrap>
    {children}
  </Space>
}
